import React, { Component } from "react";
import { Link } from "react-router-dom";
import Functions from "../../../src/functions";

class CreditSubmit extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
		});
	}

	wayOfPayment(dataFromModal) {
		let option = [];
		let UserType = Functions["custom"]["getUserType"]();
		let size =
			UserType === "HYBRID_BUSINESS_COST_CONTROL"
				? dataFromModal.prepaidService.listOfAvailableTypesOfPurchase.length
				: dataFromModal.servicesForCredit.length;
		for (let i = 0; i < size; i++) {
			let eligible =
				UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
				dataFromModal.prepaidService.listOfAvailableTypesOfPurchase[i]
					.eligibleInPortal;
			let type =
				UserType === "HYBRID_BUSINESS_COST_CONTROL"
					? dataFromModal.prepaidService.listOfAvailableTypesOfPurchase[i].type
					: dataFromModal.servicesForCredit[i].purchaseOptions.purchaseType;
			if (type === "Bill" || type === "BLNC") {
				if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
					if (eligible) {
						option.push(
							<div className="item">
								<div className="item-description">
									Επιθυμείτε να ενεργοποιήσετε το πακέτο{" "}
									<strong>
										με χρέωση στο διαθέσιμο χρηματικό σας υπόλοιπο;
									</strong>
								</div>
								<Link
									to="/thank_you"
									className="submit item-confirm bill-option">
									Επιβεβαίωση
								</Link>
							</div>,
						);
					}
				} else {
					option.push(
						<div className="item">
							<div className="item-description">
								Επιθυμείτε να ενεργοποιήσετε το πακέτο{" "}
								<strong>με χρέωση στον λογαριασμό της εταιρίας;</strong>
							</div>
							<Link
								to="/thank_you"
								className="submit item-confirm bill-option">
								Επιβεβαίωση
							</Link>
						</div>,
					);
				}
			} else if (type === "Credit" || type === "CREDIT") {
				option.push(
					<div className="item">
						<div className="item-description">
							Επιθυμείτε να ενεργοποιήσετε το πακέτο{" "}
							<strong>
								με χρέωση στην προσωπική πιστωτική/χρεωστική κάρτα σας;
							</strong>
						</div>
						<Link
							to="/submitPaymentInfo"
							className="item-confirm credit-option">
							Επιβεβαίωση
						</Link>
					</div>,
				);
			}
		}

		return option;
	}

	render() {
		if (this.state.loaded) {
			let dataFromLocal = this.state.data[0].data.data.data;
			let img = "";
			let UserType = Functions["custom"]["getUserType"]();
			let purchaseBill =
				UserType === "HYBRID_BUSINESS_COST_CONTROL"
					? JSON.parse(sessionStorage.modalData).modal
					: dataFromLocal.servicesForCredit.filter(
							(data) => data.purchaseOptions.purchaseType === "Bill",
						)[0];
			let packageTitle = purchaseBill.busServiceDes;
			try {
				const modalStorage = JSON.parse(sessionStorage.getItem("modalData"));
				if (modalStorage?.modal?.busServiceDes) {
					packageTitle = modalStorage.modal.busServiceDes;
				} else if (sessionStorage.getItem("busServiceDes")) {
					packageTitle = sessionStorage.getItem("busServiceDes");
				}
			} catch (e) {}

			if (
				purchaseBill.serviceGroup === "Extras" ||
				purchaseBill.type === "EXTRA"
			) {
				img = <img src="../../../resources/prepaid/images/30d_new.png" />;
			} else if (purchaseBill.type === "GIGA_SUMMER") {
				img = <img src="../../../resources/prepaid/images/30d_new.png" />;
			} else if (
				purchaseBill.serviceGroup === "GigaWeek" ||
				purchaseBill.type === "GIGA_WEEK"
			) {
				img = <img src="../../../resources/prepaid/images/7M_NEW.png" />;
			} else if (
				purchaseBill.serviceGroup === "Hours" ||
				purchaseBill.type === "HOURS"
			) {
				img = <img src="../../../resources/prepaid/images/24W_NEW.png" />;
			} else if (
				purchaseBill.serviceGroup === "Promo" ||
				purchaseBill.type === "PROMO"
			) {
				img = <img src="../../../resources/prepaid/images/offer.png" />;
			} else if (
				purchaseBill.serviceGroup === "IMPs" ||
				purchaseBill.type === "IMP"
			) {
				img = (
					<div className="icon">
						{purchaseBill.bundle}
						<br />
						GB
					</div>
				);
			}
			return (
				<div>
					<div className="header">
						<div className="hold">
							<a className="logo addCursorPointer"></a>
						</div>
					</div>
					<div className="card-updates">
						<div className="top">
							<div className="holder">
								<a
									href="./"
									className="back">
									← Πίσω
								</a>
								<div className="product">
									<div className="product-title">
										{packageTitle}
										<br />
									</div>
									<div className="product-icon">{img}</div>
								</div>
							</div>
						</div>
						<div className="title">Επιλέξτε τρόπο πληρωμής</div>
						<div className="text">
							Έχετε επιλέξει το πακέτο <strong> {packageTitle} </strong>
							<strong>
								για {purchaseBill.period}{" "}
								{UserType === "HYBRID_BUSINESS_COST_CONTROL"
									? purchaseBill.tariffMeasunitTeaserFormated
									: purchaseBill.periodMeasunit}
							</strong>{" "}
							με <strong>{purchaseBill.tariff}€</strong>. Για να συνεχίστε
							επιλέξτε μία από τις επιλογές:
						</div>
						<div className="items">{this.wayOfPayment(dataFromLocal)}</div>
					</div>
				</div>
			);
		} else {
			return "";
		}
	}
}

export default CreditSubmit;
